import { lazyLoadView } from '@router/helpers'
import store from '@state/store'

export default [
  {
    path: '/profile',
    name: 'profile',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "profile" */ './views/profile.vue')
      ),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:userId',
    name: 'user-profile',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "profile" */ './views/profile.vue')
      ),
    meta: {
      authRequired: true,
      // HACK: In order to share data between the `beforeResolve` hook
      // and the `props` function, we must create an object for temporary
      // data only used during route resolution.
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        handleRoute()
        function handleRoute() {
          store
            // Try to fetch the user's information by their username
            .dispatch('users/fetchUser', { userId: routeTo.params.userId })
            .then((user) => {
              // Add the user to `meta.tmp`, so that it can
              // be provided as a prop.
              routeTo.meta.tmp.user = user
              // Continue to the route.
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'User' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.meta.tmp.user }),
  },
  {
    path: '/user/:userId',
    name: 'user-page',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "profile" */ './views/user.vue')
      ),
    meta: {
      authRequired: true,
      // HACK: In order to share data between the `beforeResolve` hook
      // and the `props` function, we must create an object for temporary
      // data only used during route resolution.
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        handleRoute()
        function handleRoute() {
          store
            // Try to fetch the user's information by their username
            .dispatch('users/fetchUser', { userId: routeTo.params.userId })
            .then((user) => {
              // Add the user to `meta.tmp`, so that it can
              // be provided as a prop.
              routeTo.meta.tmp.user = user
              store
                .dispatch('users/fetchStatusUpdates', {
                  userId: routeTo.params.userId,
                  pageNr: 1,
                })
                .then((posts) => {
                  routeTo.meta.tmp.postsCount = posts.length

                  next()
                })
                .catch(() => {
                  next({ name: '404', params: { resource: 'User' } })
                })
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'User' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      user: route.meta.tmp.user,
      postsCount: route.meta.tmp.postsCount,
    }),
  },
]
